import { createContext, useContext } from 'react';

interface SidebarContextValue {
  toggleSidebar: () => void;
  isSidebarCollapsed: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const SidebarContext = createContext<SidebarContextValue>({
  toggleSidebar: noop,
  isSidebarCollapsed: false,
});

export const useSidebar = () => useContext(SidebarContext);
